<template>
<div class="error">
    <div class="content">
        <p><img src="../../static/images/error.png" alt=""></p>
        <p class="tips">操作失败</p>
        <p class="tipsmsg">{{title}}</p>
        <p class="back"><button class="applylist" v-show="order_id!=0" @click="applylist">重新支付</button><button @click="Backindex">返回首页</button></p>
    </div>
</div>
</template>

<script>
export default {
    data(){
        return{
            order_id:0,
            title:"非法操作"
        }
    },
    created(){
        this.order_id = this.$route.query.order_id || 0;
        if(this.order_id!=0){
            this.title="订单支付失败"
        }
    },
    methods:{
        Backindex(){
            this.$router.push('/')
        },
        applylist(){
            this.$router.push('/cashier?order_id=' + this.order_id )
        }
    }
}

</script>

<style lang="scss" scoped>
    .error{
        height: 100%;
        width: 100%;
        background: #ffffff;
        .content{
            padding-top: 40%;
            p{
                text-align: center;
                img{
                    width: 1.5rem;
                }
            }
            .tips{
                font-size: 18px;
                color: #000000;
                font-weight: bold;
                padding-top: 0.4rem;
            }
            .tipsmsg{
                font-size: 14px;
                padding-top: 0.2rem;
            }
            button{
                background: #299e72;
                border-radius: 20px;
                padding: 0.1rem 0.5rem;
                color: #ffff;
            }
            .back{
                padding-top: 0.6rem;
                .applylist{
                    background: #ffb260;
                    margin-right: 0.2rem;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/error.vue